module.exports = __webpack_public_path__ + "img/login-elrecreo.036039bb.svg";